export default __webpack_public_path__ + "static/media/caret-down.da826d61.svg";